import StaticContentPage from './StaticContentPage';

export default function RefundPolicyPage() {
  return <StaticContentPage slug="refunds" fallbackTitle="Refunds and Cancellation Policy" />;
}

